module.exports = __webpack_public_path__ + "img/jifen12.67134fcc.png";